import React from 'react';
import ReactDOM from 'react-dom/client';
import { APP_ANCHOR } from './config/app';
import ErrorBoundary from './components/ErrorBoundary';
import AppContextProvider from './context/Provider';
import App from './components/Container';
import './index.css';

const sensorPortalTarget = document.getElementById(APP_ANCHOR);

if (sensorPortalTarget) {
	const appRoot = ReactDOM.createRoot(sensorPortalTarget);
	appRoot.render(
		<React.StrictMode>
			<ErrorBoundary>
				<AppContextProvider>
					<App />
				</AppContextProvider>
			</ErrorBoundary>
		</React.StrictMode>,
	);
}
